import React from "react";
import OrgIcon from "../../../assets/images/org.png";
import { Email, DesktopMac, VpnKey } from "@material-ui/icons";
import HistoryIcon from "@material-ui/icons/History";
export const menus = [
  {
    id: "dashboard",
    title: "Dashboard",
    muiIcon: () => <DesktopMac style={{ margin: 0 }} />,
    path: "/admin",
  },
  {
    id: "organizations",
    title: "Organizations",
    icon: OrgIcon,
    path: "/admin/organizations",
  },
  {
    id: "invitation",
    title: "Invite Users",
    muiIcon: () => <Email style={{ margin: 0 }} />,
    path: "/admin/invitation",
  },
  {
    id: "user-password",
    title: "User Password",
    muiIcon: () => <VpnKey style={{ margin: 0 }} />,
    path: "/admin/user-password",
  },
  {
    id: "invoices",
    title: "Invoices",
    muiIcon: () => <HistoryIcon style={{ margin: 0 }} />,
    path: "/admin/invoices",
  },
  /* {
    id: "activity",
    title: "Activity",
    icon: ActivityIcon,
    path: "/admin/activity"
  } */
];
